module.exports = __webpack_public_path__ + "img/banner-linepen.2920c1c7.png";